export const formatHeaderPDF = (cabecera) => { 
    if (!cabecera) return {};

    // ---- FORMATEAR FECHA ----
    let fechaFormateada = "";
    if (cabecera.createdAt) {
        const fecha = new Date(cabecera.createdAt);

        const dia = String(fecha.getDate()).padStart(2, "0");
        const mes = String(fecha.getMonth() + 1).padStart(2, "0");
        const anio = fecha.getFullYear();

        const hora = String(fecha.getHours()).padStart(2, "0");
        const minuto = String(fecha.getMinutes()).padStart(2, "0");

        fechaFormateada = `${dia}/${mes}/${anio} ${hora}:${minuto}`;
    }

    // ---- CATEGORÍA ----
    let categoria = "No definida";
    if (cabecera.categ_id !== undefined && cabecera.categ_id !== null) {
        switch (Number(cabecera.categ_id)) {
            case 0: categoria = "Mayorista"; break;
            case 1: categoria = "Minorista"; break;
            case 2: categoria = "Costo"; break;
        }
    }
     // ---- FORMA DE PAGO ----
    let formapago = "No definida";
    if (cabecera.formapago !== undefined && cabecera.formapago !== null) {
        switch (Number(cabecera.formapago)) {
            case 0: formapago = "Pago en el local"; break;
            case 1: formapago = "Transferencia"; break;
            case 2: formapago = "MercadoPago"; break;
        }
    }

    // ---- VENDEDOR (solo si tiene ambos nombres) ----
    const vendedor =
        cabecera.sel_firstname && cabecera.sel_lastname
            ? `${cabecera.sel_firstname} ${cabecera.sel_lastname}`
            : "-";

    // ---- RETORNO FINAL ----
    return {
        pedido: cabecera.id || "-",
        codcliente: cabecera.cli_codigo || "-",
        cliente: cabecera.cli_name || "-",
        categoria,
        direccion: cabecera.cli_direccion || "-",
        telefono: cabecera.cli_tel || "-",
        fecha: fechaFormateada || "-",
        vendedor,
        formapago,
        totaldesc: cabecera.totalpedidodesc ?? 0,
        total: cabecera.totalpedido ?? 0,
    };
};
